export const COLORS = {
  primary: "#9c27b0",
  success: "#4caf50",
  warning: "#ff9800",
  info: "#1e88e5",
  dark: "#212121",
  cardBg: "#ffffff",
  pageBg: "#f5f5f5",
  muted: "#9e9e9e",
};

export const TIPO_COLOR = {
  urgencia: COLORS.warning,
  turno: COLORS.info,
  recepcion: COLORS.primary,
  guardia: COLORS.warning,
  paciente_nuevo: "#8bc34a",
  otro: COLORS.muted,
};

export const TIPO_LABEL = {
  urgencia: "Urgencia",
  turno: "Turno",
  recepcion: "Recepción",
  guardia: "Guardia",
  paciente_nuevo: "Paciente Nuevo",
  otro: "Otro",
};

export const formatHora = (hora) =>
  hora ? `${hora.slice(0, 2)}:${hora.slice(2)} hs` : null;
